import { ConfigProvider, TreeSelect } from "antd";
import faIR from "antd/lib/locale/fa_IR";
import "./styles.scss";
import { normalizeTreeResponse } from "../DBSearchableTree/treeUtils";

const { TreeNode } = TreeSelect;

export default function TreeSearchSelect({
    data,
    value,
    onChange,
    placeholder,
    size,
    status,
    onClick,
    disabled,
    multiple = false,
    className,
    maxTagCount = 4,
}) {
    const printChildren = (nodes) => {
        return normalizeTreeResponse(nodes).map((item) => (
            <TreeNode key={item.id} value={item.id} title={item.name}>
                {item.children?.length > 0
                    ? printChildren(item.children)
                    : null}
            </TreeNode>
        ));
    };

    const handleChange = (next, ...rest) => {
        if (!onChange) return;
        if (!multiple) {
            onChange(next, ...rest);
            return;
        }
        const selected = (Array.isArray(next) ? next : []).map((item) =>
            item && typeof item === "object" ? item.value : item
        );
        onChange(selected, ...rest);
    };

    const selectValue = multiple
        ? Array.isArray(value) && value.length
            ? value
            : undefined
        : value;

    return (
        <ConfigProvider locale={faIR} direction="rtl">
            <TreeSelect
                disabled={disabled}
                onClick={onClick}
                status={status}
                showSearch
                multiple={multiple}
                treeCheckable={multiple}
                showCheckedStrategy={TreeSelect.SHOW_PARENT}
                maxTagCount={multiple ? maxTagCount : undefined}
                style={{ width: "100%" }}
                className={className}
                dropdownStyle={{
                    maxHeight: 400,
                    overflow: "auto",
                    zIndex: 999999,
                }}
                placeholder={placeholder || "انتخاب کنید"}
                allowClear
                treeDefaultExpandAll={!multiple}
                treeDefaultExpandedKeys={
                    multiple
                        ? normalizeTreeResponse(data).map((item) => item.id)
                        : undefined
                }
                treeNodeFilterProp="title"
                treeLine
                value={selectValue}
                onChange={handleChange}
                size={size}
            >
                {printChildren(data)}
            </TreeSelect>
        </ConfigProvider>
    );
}

